<template>
  <v-container id="vencimientos" fluid>
    <base-material-card color="#ac8a2e" icon="mdi-account-box" inline class="px-5 py-3" title="Contratos a vencer">
      <v-row>
        <v-col cols="12" md="4">
          <v-menu ref="fechaMin" v-model="fechaMin" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
            <template v-slot:activator="{ on }">
              <v-text-field v-model="fMin" color="gold" label="Fecha desde" readonly v-on="on" />
            </template>
            <v-date-picker v-model="fMin" color="gold" landscape scrollable locale="es-419" no-title @input="fechaMin = false" />
          </v-menu>
        </v-col>
        <v-col cols="12" md="4">
          <v-menu ref="fechaMax" v-model="fechaMax" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
            <template v-slot:activator="{ on }">
              <v-text-field v-model="fMax" color="gold" label="Fecha hasta" readonly v-on="on" />
            </template>
            <v-date-picker v-model="fMax" color="gold" landscape scrollable locale="es-419" no-title @input="fechaMax = false" />
          </v-menu>
        </v-col>
        <v-col cols="12" md="auto" align-self="center" @click="getDataConTotal">
          <v-btn fab dark small color="indigo">
            <v-icon dark>
              mdi-magnify
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        v-if="renderTable"
        :headers="headers"
        :items="contratos.data"
        :page-count="contratos.last_page"
        :page="contratos.current_page"
        :server-items-length="contratos.total"
        :sort-by="sortby"
        :sort-desc="sortdesc"
        :footer-props="{
          itemsPerPageOptions: itemsPerPage
        }"
        @update:options="getData($event)"
      >
        <template v-slot:[`item.documentacion`]="{ item }">
          <upload-files icono folder="/documentaciones/contratos" tipo="pdf" :documento-id="item.documentacion_id" />
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  import UploadFiles from '../../components/base/UploadFiles.vue'
  import dayjs from 'dayjs'

  export default {
    name: 'Vencimientos',
    components: { UploadFiles },
    props: {},
    data () {
      return {
        headers: [
          { text: 'Tipo Contrato', value: 'tipoContrato' },
          { text: 'Jugador', sortable: true, value: 'full_name' },
          { text: 'Valido desde', value: 'valido_desde' },
          { text: 'Valido hasta ', value: 'valido_hasta' },
          { text: 'Doc.', value: 'documentacion' },
        ],
        tipoContrato: [],
        fechaMax: false,
        fechaMin: false,
        fMin: '',
        fMax: '',
        renderTable: false,
        sortby: ['valido_hasta'],
        sortdesc: [false],
        op: {},
        loading: false,
        contratos: [],
        itemsPerPage: [5, 10, 15],
      }
    },
    computed: {},
    created () {
      this.inic()
    },
    methods: {
      getData (data) {
        this.op = data
        this.readDataFromAPI(data.page, data.sortBy, data.sortDesc, data.itemsPerPage)
      },
      getDataConTotal () {
        this.readDataFromAPI(1, this.op.sortBy, this.op.sortDesc, this.op.itemsPerPage)
      },
      readDataFromAPI: async function (page = 1, sortBy, sortDesc, perPage = 5) {
        this.loading = true
        this.$store.dispatch('axiosMod/getData', {
          url: '/api/contrato_vencimiento/' + '?page=' + page + '&fmin=' + this.fMin + '&fmax=' + this.fMax + '&sortBy=' +
            sortBy + '&sortDesc=' + sortDesc + '&itemsPerPage=' + perPage,
        }).then(response => {
          this.contratos = response
          this.loading = false
        })
      },
      inic () {
        this.getTiposContratos()
        const today = dayjs()
        this.fMin = today.format('YYYY-MM-DD')
        this.fMax = dayjs(today.add(6, 'month')).format('YYYY-MM-DD')
        this.renderTable = true
      },
      getTiposContratos () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/tipo_contrato_get' }).then(response => {
          this.tipoContrato = response
        })
      },
    },
  }
</script>
